import { gql } from '@apollo/client';

export const Allergens = gql`query Allergens {
  allergens {
    title
    _id
  }
}`;
